import * as STD from '@emersya/mpa-std-lib';
import CM from '@emersya/mpa-components-manager-lib';

export interface IMPAEngineConfiguratorMenuComponentConfiguration extends CM.DOMComponent.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

export class MPAEngineConfiguratorMenuComponent extends CM.DOMComponent<
	HTMLDivElement,
	MPAEngineConfiguratorMenuComponent,
	IMPAEngineConfiguratorMenuComponentConfiguration
> {
	static override initialize() {
		super.initialize();
	};

	component_DOM: HTMLDivElement;

	private async addUIModule(module: EngineModule.UIEngineModule<any>) {
		const sectionsIcons = this.component_find('@:sectionsIcons');
		const panel = this.component_find('@:panel');

		// Section icons
		{
			const iconButton = <CM.DOMComponent<any, any, any>>await sectionsIcons.component_instantiateOuterChild(
				{
					type: 'input-button',
					id: module.id,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			const iconImage = <CM.DOMComponent<any, any, any>>await iconButton.component_instantiateOuterChild(
				{
					type: 'image',
					id: 'icon',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {
						'@translations': {
							'@name': module.translations['@name']
						}
					}
				}
			);
			void iconButton;
			void iconImage;
		}
		// Panel
		{
			const section = <CM.DOMComponent<any, any, any>>await panel.component_instantiateOuterChild(
				{
					type: 'section',
					id: module.id,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			const header = <CM.DOMComponent<any, any, any>>await section.component_instantiateOuterChild(
				{
					type: 'input-button',
					id: 'header',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			const headerTitles = <CM.DOMComponent<any, any, any>>await header.component_instantiateOuterChild(
				{
					type: 'block',
					id: '-',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			const headerTitlesSection = <CM.DOMComponent<any, any, any>>await headerTitles.component_instantiateOuterChild(
				{
					type: 'text',
					id: 'title',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			headerTitlesSection.component_DOM.classList.add('text-title-section');
			/**
			 * headerTitlesSelected = Not used anymore?
			 **/
			const headerTitlesSelected = <CM.DOMComponent<any, any, any>>await headerTitles.component_instantiateOuterChild(
				{
					type: 'text',
					id: 'selected',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {}
				}
			);
			const headerOpen = <CM.DOMComponent<any, any, any>>await header.component_instantiateOuterChild(
				{
					type: 'input-button',
					id: 'open',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {
						'@classList': ['icon'],
						'@stringData': 'Ù'
					}
				}
			);
			const headerClose = <CM.DOMComponent<any, any, any>>await header.component_instantiateOuterChild(
				{
					type: 'input-button',
					id: 'close',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: {
						'@classList': ['icon'],
						'@stringData': 'q'
					}
				}
			);
			const content = <CM.DOMComponent<any, any, any>>await section.component_instantiateOuterChild(
				{
					type: module.id,
					id: 'content',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					declaredSlot: null,
					configuration: await module.generateComponentConfiguration.call(module)
				}
			);
			(<any>module).component = content;
			void content;
			void headerTitlesSection;
			void headerTitlesSelected;
			void headerOpen;
			void headerClose;
		}
		void panel;
	};

	private async addLogicalModule(module: EngineModule.LogicalEngineModule<any>) {
		if (!module.insertionPath) {
			return;
		}
		if (!module.generateComponentConfiguration) {
			this.component_throwUserError('');
		}
		const parent = app.component_find(module.insertionPath);
		(<any>module).component = <CM.DOMComponent<any, any, any>>await parent.component_instantiateOuterChild(
			{
				type: module.id,
				id: module.id,
				tree: this.component_tree,
				slot: null,
				isSlot: false,
				declaredSlot: null,
				configuration: await module.generateComponentConfiguration.call(module)
			}
		);
	};

	override async component_initialize() {
		for (const module of EngineModule.usedWithPageOrdered) {
			await this.addUIModule(module);
		}
		for (const module of EngineModule.used.filter(x => x.type === 'logical')) {
			await this.addLogicalModule(<EngineModule.LogicalEngineModule<any>>module);
		}
		await super.component_initialize();
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IMPAEngineConfiguratorMenuComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = MPAEngineConfiguratorMenuComponent;
	export type Component = MPAEngineConfiguratorMenuComponent;
	export type Configuration = IMPAEngineConfiguratorMenuComponentConfiguration;
}
;
import manifestXMLSource from './MPAEngineConfiguratorMenu.xml';
import './MPAEngineConfiguratorMenu.scss';
import EngineModule from '../../../EngineModule';

CM.declare({
	id: 'mpaengine-configuratorMenu',
	type: MPAEngineConfiguratorMenuComponent,
	manifest: manifestXMLSource
});
